import React from 'react';
import styled from 'styled-components';
import StyledText from 'typography/StyledText';

import { useI18n } from '../../locales';
import { getCurrencySymbol } from '../../state/atoms/pricing';

const SecurityDepositContainer = styled.div`
	margin: 16px 0 0 0;
	text-align: left;
	display: flex;
	align-items: center;
	justify-content: center;
`;

interface ISecurityDeposit {
	currency: string;
	securityDeposit: number;
	typographyTextType?:
		| 'body'
		| 'caption'
		| 'label'
		| 'lead'
		| 'body_longform'
		| 'footnote';
	className?: string;
}

const SecurityDeposit: React.FC<ISecurityDeposit> = ({
	currency,
	securityDeposit,
	typographyTextType = 'label',
	className,
}) => {
	const t = useI18n();

	if (!securityDeposit) return null;
	const symbol = getCurrencySymbol(currency);
	return (
		<SecurityDepositContainer className={className}>
			<StyledText type={typographyTextType}>
				{t('SecurityDeposit.title', { symbol, securityDeposit })}
			</StyledText>
		</SecurityDepositContainer>
	);
};

export default SecurityDeposit;
